import { render, staticRenderFns } from "./ReturnListFunc.vue?vue&type=template&id=3712aad0&scoped=true"
import script from "./ReturnListFunc.vue?vue&type=script&lang=js"
export * from "./ReturnListFunc.vue?vue&type=script&lang=js"
import style0 from "./ReturnListFunc.vue?vue&type=style&index=0&id=3712aad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3712aad0",
  null
  
)

export default component.exports